export default {
  actions: {
    async api_request({ getters, dispatch }, { endpoint, headers, body}) {

      let options = {
        headers: headers || {}
      }

      if (getters.token != undefined) {
        options.headers.token = getters.token
      }

      if (body) {
        options.method = 'POST'
        options.headers['Content-type'] = 'application/json'
        options.body = JSON.stringify(body)
      }
      
      let response = await fetch(getters.url+'/api/v1'+endpoint, options)
      response = await response.json()

      if (!response.result) {
        console.error(`Request ${endpoint} failed: (${response.error_class}) ${response.error_text}`)
        await dispatch('raise', response)

        if (response.error_class == 'GSUnauthorized') {
          await dispatch('set_token', undefined)
        }

        throw new Error(response.error_text)
      } else {
        return response.data
      }
    },
  },
  getters: {
    url(){
      return process.env.NODE_ENV == 'development' ? 'http://127.0.0.1:7000' : ''
    }
  }
}